module.exports = __webpack_public_path__ + "static/img/official_card.8d91c28.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/preview_img/official_card.jpg
// module id = 4T28
// module chunks = 30